import * as ts from "../../common/Translator";
import * as buttons from "../../constants/EditToolbarButtons";
import {
    userCan,
    userCanApprove,
    userCanCreate,
    userCanDelete,
    userCanDeleteDraft,
    userCanEdit,
    userCanList,
    userCanNotEdit,
    userCanView
} from "../../login/Security";
import * as CapabilityType from '../../constants/CapabilityType'
import * as GenerationType from "../../constants/GenerationType";
import * as ViewMode from '../../constants/ViewMode'
import {findEntityMaxReviseCount, isDocument} from "../../login/ClientCache";
import {currentUserEmployeeId} from "../../login/LoginPresenter";
import * as OutputFormat from "../../constants/OutputFormat";
import {TreeViewImpl} from "../treeView/TreeViewImpl";
import {TreeViewForEditView} from "../treeView/TreeViewForEditView";
import {hasParentEntity} from "../treeView/TreeViewForListView";
import * as cmn from "../../common/NamaCommon";
import * as NamaURLS from "../../constants/NamaURLS";
import {describe, getFunctionShortCut} from "../../common/ShortCutsUtil";
import {isMobileDevice, showHelpMSGs} from "../../common/GUIUtilities";
import {showExportDialog} from "../list/ListScreenLayout";
import {initGoToHome} from "../Navbar";

export function fillMoreMenuButtons(toolbar, buttons) {
    for (let button of buttons) {
        let buttonId = button.id;
        let buttonTitle = button.title;
        let parentButtonId = button.parentButtonId;
        if (!buttonId) {
            if (parentButtonId) {
                //$(`#moreMenu`).items.Add().Type(CommandType.Separator);
            }
        } else {
            if (parentButtonId)
                $(`#moreMenu_optionlist #${parentButtonId}`).append(`<li><a class='k-button' id = ${buttonId}>${buttonTitle}</a></li>`);
            else
                $("#moreMenu_optionlist").append(`<li><a class='k-split-button' id = ${buttonId}>${buttonTitle}</a></li>`);
            $(`#${buttonId}`).on("click", (e) => {
                $("#moreMenu_optionlist .k-split-button").remove();
                $("#moreMenu_optionlist .k-button").remove();
                button.clickFunction.call();
            });
        }
    }
}

export function calcBtnTitle(btnId) {
    let title = ts.translateId("BusinessFunction." + btnId);
    let shortCut = getFunctionShortCut(btnId);
    if (shortCut) {
        title += describe(shortCut);
    }
    return title;
}

export function initEditScreenToolbar(toolbar, presenter) {
    let buttons = toolbar.find("a[role=button]");
    if (buttons.length) {
        for (let i = 0; i < buttons.length; i++) {
            let current = $(buttons[i]);
            if (current.attr("data-business-func"))
                current.attr('title', calcBtnTitle(current.attr("data-business-func")));
        }
    }
    toolbar.find("#newRecord").click(() => presenter.onNewRecord());
    toolbar.find("#saveBtn").click(() => presenter.saveRecord());
    toolbar.find("#saveAndContinueBtn").click(() => presenter.saveAndContinue());
    toolbar.find("#duplicateBtn").click(() => presenter.duplicateRecord());
    toolbar.find("#saveDraftBtn").click(() => presenter.saveDraft());
    toolbar.find("#printBtn").click(() => presenter.onPrint(OutputFormat.PDF));
    toolbar.find(".btn-printing").click(() => showExportDialog(presenter));
    toolbar.find("#approvalBtn").click(() => presenter.onApprove());
    toolbar.find("#reviseBtn").click(() => presenter.revise());
    toolbar.find("#unReviseBtn").click(() => presenter.unRevise());
    toolbar.find("#listView").click(() => presenter.onListView());
    toolbar.find("#refreshBtn").click(() => presenter.onRefresh());
    toolbar.find("#showHelpMsgs").click(() => {
        if (!localStorage.getItem("showHelpsIsActive")) {
            showHelpMSGs(presenter);
        } else {
            localStorage.removeItem("showHelpsIsActive");
            presenter.start();
        }
    });
    toolbar.find("#treeViewBtn").click(() => presenter.treeView());
    toolbar.find("#firstBtn").click(() => presenter.navigateFirst());
    toolbar.find("#previousBtn").click(() => presenter.navigatePrevious());
    toolbar.find("#nextBtn").click(() => presenter.navigateNext());
    toolbar.find("#lastBtn").click(() => presenter.navigateLast());
    toolbar.find("#deleteBtn").click(() => presenter.onDelete());
    toolbar.find("#moreMenu").click(() => presenter.showMoreMenu());
    initGoToHome(toolbar.find("#homeBtn"));
}

export function initTreeViewForEditing(splitter, presenter) {
    if (presenter.hasTree() && !splitter.data("kendoSplitter")) {
        let treeViewForEditView = new TreeViewForEditView(presenter.entityType);
        let treeViewImpl = new TreeViewImpl(treeViewForEditView.getTreeModelProviderForEditView(),
            treeViewForEditView.getHelperForEditView(), presenter, () => onTreeNodeSelection(treeViewImpl, presenter));
        presenter.treeView = treeViewImpl;
        treeViewImpl.drawTreeView();
        let treeWidth = "250px";
        if (isMobileDevice())
            treeWidth = "150px";
        splitter.kendoSplitter({
            panes: [
                {collapsible: false},
                {collapsible: true, size: treeWidth, collapsed: true},
            ]
        }).data("kendoSplitter");
        $(".tree-view-btn, .k-close-treeview-mobile").click(function (e) {

            splitter.toggle("#paneTreeView");
        });

    } else if (splitter.data("kendoSplitter")) {
        splitter.data("kendoSplitter").toggle(".k-pane:last");
    }
}

function onTreeNodeSelection(treeViewImpl, presenter) {
    let selectedNode = treeViewImpl.getSelectedNode();
    if (selectedNode.id === presenter.place.id)
        return;
    cmn.ajaxJSON(NamaURLS.FIND_BY_ID, {
        entityType: treeViewImpl.treeModelProvider.entityType,
        id: selectedNode.id
    }, (result) => {
        let record = result.data;
        presenter.place.id = selectedNode.id;
        if (presenter.place.view === ViewMode.NEW)
            presenter.place.view = ViewMode.EDIT;
        presenter.editRecord(record, true)
    });

}

function preValidateCreateNewRecord(presenter) {
    if (userCanEdit(presenter.entityType))
        return true;
    return userCanCreate(presenter.entityType);
}

function preValidateSaveAndContinue(presenter) {
    return preValidateSave(presenter) && preValidateCreateNewRecord(presenter);
}

function preValidateSave(presenter) {
    if (userCanNotEdit(presenter.entityType))
        return false;
    return preValidateEditedObjectRelatedButton(presenter);
}

function preValidateEditedObjectRelatedButton(presenter) {
    return presenter.record === null ? false : defaultToolBarButtonState(presenter);
}

function defaultToolBarButtonState(presenter) {
    return !presenter.isViewOnlyMode();
}

function isRevised(presenter) {
    let record = presenter.record;
    if (!record)
        return false;
    return record.revised;
}

export function isInNewMode(presenter) {
    return presenter.place.view === ViewMode.NEW;
}

function canDuplicate(presenter) {
    return !isInNewMode(presenter) && userCan(presenter.entityType, CapabilityType.Duplicate)
        && presenter.findGenerationType() !== GenerationType.GeneratedFinal;
}

function preValidateSaveDraft(presenter) {
    if (presenter.isViewOnlyMode())
        return false;
    if (isDocument(presenter.entityType)
        && presenter.record.commitedBefore === true)
        return false;
    if (userCanEdit(presenter.entityType))
        return true;
    return userCan(presenter.entityType, CapabilityType.SaveDraft);
}

function preValidateRefresh() {
    return true;
}

function preValidatePrint() {
    return defaultToolBarNavigationButtonState();
}

function defaultToolBarNavigationButtonState() {
    return true;
}

function preValidateGoToListView(presenter) {
    if (!userCanList(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateGoToRecord(presenter) {
    if (!userCanView(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateGoToFirstRecord(presenter) {
    if (!userCanView(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateGoToLastRecord(presenter) {
    if (!userCanView(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateGoToPreviousRecord(presenter) {
    if (!userCanView(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateGoToNextRecord(presenter) {
    if (!userCanView(presenter.entityType))
        return false;
    return defaultToolBarNavigationButtonState();
}

function preValidateDelete(presenter) {
    if (presenter.isNotEditableBySystem() || presenter.place.view === ViewMode.NEW)
        return false;
    if (presenter.record.commitedBefore === true)
        return userCanDelete(presenter.entityType);
    else
        return userCanDeleteDraft(presenter.entityType);
}

function preValidateApproval(presenter) {
    if (!userCanApprove(presenter.entityType))
        return false;
    if (!presenter.isApprovalPending())
        return false;
    return isUserEmployeeCandidate(presenter);
}

function isUserEmployeeCandidate(presenter) {
    let currentCandidates = presenter.record.currentApprovalCase ? presenter.record.currentApprovalCase.currentCandidates : "";
    return currentCandidates && currentCandidates.contains(currentUserEmployeeId());

}

function preValidateRevise(presenter) {
    if (!canBeRevised(presenter))
        return false;
    return userCan(presenter.entityType, CapabilityType.Revise
        + toReviseLevel(currentReviseLevelInt(presenter) + 1));
}

function toReviseLevel(level) {
    return "L" + level;
}

export function canBeRevised(presenter) {
    let revisedLevel = currentReviseLevelInt(presenter);
    let toBeRevisedCount = findEntityMaxReviseCount(presenter.entityType).reviseLevel;
    if (revisedLevel < toBeRevisedCount)
        return true;
    return false;
}

function currentReviseLevelInt(presenter) {
    if (shouldPreserveBackwardCompatibility(presenter))
        return 1;
    if (presenter.record === null)
        return 0;
    let levelString = presenter.record.reviseLevel;
    if (!levelString)
        return 0;
    return levelString.replace("L", "");

}

function shouldPreserveBackwardCompatibility(presenter) {
    return presenter.record && !presenter.record.reviseLevel && isRevised(presenter);
}

function preValidateUnrevise(presenter) {
    if (!canBeUnRevised(presenter))
        return false;
    return userCan(presenter.entityType, CapabilityType.Unrevise + currentReviseLevel(presenter));

}

function currentReviseLevel(presenter) {
    let currentLevel = currentReviseLevelInt(presenter);
    if (currentLevel === 0)
        return "";
    return toReviseLevel(currentLevel);
}

export function canBeUnRevised(presenter) {
    let revisedCount = currentReviseLevelInt(presenter);
    if (revisedCount > 0)
        return true;
    return false;
}

export function supportsTree(entityType) {
    return hasParentEntity(entityType);
}

function prevalidateTreeView(presenter) {
    return supportsTree(presenter.entityType);
}

function prevalidateBtn(presenter, toolbar, type, btnId) {
    if (!enableButton(type, presenter))
        toolbar.find(btnId).addClass("k-disabled");
    else
        toolbar.find(btnId).removeClass("k-disabled");
}

export function prevalidateToolbarButtons(toolbar, presenter) {
    prevalidateBtn(presenter, toolbar, buttons.NEW_RECORD, "#newRecord");
    prevalidateBtn(presenter, toolbar, buttons.SAVE_AND_CONTINUE, "#saveAndContinueBtn");
    prevalidateBtn(presenter, toolbar, buttons.DUPLICATE, "#duplicateBtn");
    prevalidateBtn(presenter, toolbar, buttons.SAVE, "#saveBtn");
    prevalidateBtn(presenter, toolbar, buttons.SAVE_DRAFT, "#saveDraftBtn");
    prevalidateBtn(presenter, toolbar, buttons.REFRESH, "#refreshBtn");
    prevalidateBtn(presenter, toolbar, buttons.PRINT, "#printBtn");
    prevalidateBtn(presenter, toolbar, buttons.LIST_VIEW, "#listView");
    prevalidateBtn(presenter, toolbar, buttons.GO_TO_RECORD, "#goToRecordBtn");
    prevalidateBtn(presenter, toolbar, buttons.FIRST, "#firstBtn");
    prevalidateBtn(presenter, toolbar, buttons.PREVIOUS, "#previousBtn");
    prevalidateBtn(presenter, toolbar, buttons.NEXT, "#nextBtn");
    prevalidateBtn(presenter, toolbar, buttons.LAST, "#lastBtn");
    prevalidateBtn(presenter, toolbar, buttons.DELETE, "#deleteBtn");
    prevalidateBtn(presenter, toolbar, buttons.APPROVAL, "#approvalBtn");
    prevalidateBtn(presenter, toolbar, buttons.REVISE, "#reviseBtn");
    prevalidateBtn(presenter, toolbar, buttons.UNREVISE, "#unReviseBtn");
    prevalidateBtn(presenter, toolbar, buttons.TREE_VIEW, "#treeViewBtn");
}

function enableButton(id, presenter) {
    if (buttons.NEW_RECORD.equalsIgnoreCase(id))
        return preValidateCreateNewRecord(presenter);
    if (buttons.SAVE_AND_CONTINUE.equalsIgnoreCase(id))
        return preValidateSaveAndContinue(presenter);
    if (buttons.DUPLICATE.equalsIgnoreCase(id))
        return canDuplicate(presenter);
    else if (buttons.SAVE.equalsIgnoreCase(id))
        return preValidateSave(presenter);
    else if (buttons.SAVE_DRAFT.equalsIgnoreCase(id))
        return preValidateSaveDraft(presenter);
    else if (buttons.REFRESH.equalsIgnoreCase(id))
        return preValidateRefresh();
    else if (buttons.PRINT.equalsIgnoreCase(id))
        return preValidatePrint();
    else if (buttons.LIST_VIEW.equalsIgnoreCase(id))
        return preValidateGoToListView(presenter);
    else if (buttons.GO_TO_RECORD.equalsIgnoreCase(id))
        return preValidateGoToRecord(presenter);
    else if (buttons.FIRST.equalsIgnoreCase(id))
        return preValidateGoToFirstRecord(presenter);
    else if (buttons.PREVIOUS.equalsIgnoreCase(id))
        return preValidateGoToPreviousRecord(presenter);
    else if (buttons.NEXT.equalsIgnoreCase(id))
        return preValidateGoToNextRecord(presenter);
    else if (buttons.LAST.equalsIgnoreCase(id))
        return preValidateGoToLastRecord(presenter);
    else if (buttons.DELETE.equalsIgnoreCase(id))
        return preValidateDelete(presenter);
    else if (buttons.APPROVAL.equalsIgnoreCase(id))
        return preValidateApproval(presenter);
    else if (buttons.REVISE.equalsIgnoreCase(id))
        return preValidateRevise(presenter);
    else if (buttons.UNREVISE.equalsIgnoreCase(id))
        return preValidateUnrevise(presenter);
    else if (buttons.TREE_VIEW.equalsIgnoreCase(id))
        return prevalidateTreeView(presenter);
    return defaultToolBarNavigationButtonState();
}
